export default {
  bankpay: {
    title: "Виписки банку, платіжні документи",
    bankStat: {
      modal: {
        title: "Виписка банку"
      },
      form: {
        datebank: {
          title: "Дата з банку"
        },
        quantity: {
          title: "Кількість платежів"
        },
        summa: {
          title: "Сума платежів"
        },
        accountid: {
          title: "Р/рахунок-одержувач"
        }
      }
    },
    payDocEdit: {
      modal: {
        title: "Платіжний документ"
      },
      form: {
        paymentStatus: {
          title: "Платіж"
        },
        paynumber: {
          title: "№ документа"
        },
        okpo: {
          title: "ОКПО"
        },
        datepay: {
          title: "Дата оплати"
        },
        codefirme: {
          title: "Відправник"
        },
        summa: {
          title: "Сума"
        },
        astatus: {
          title: "сума включає ком. збір"
        },
        kindpay: {
          title: "Спосіб оплати"
        },
        mess: {
          title: "Примітка"
        }
      }
    },
    uploadFiles: {
      modal: {
        title: "Завантаження файлів"
      },
      form: {
        encoding: {
          title: "Кодування"
        },
        uploadfile: {
          title: "Завантаження"
        }
      }
    },
    confirm: {
      modal: {
        title: "Організація-відправник"
      },
      form: {
        info: {
          title:
            "Виберіть організацію, яка відправила платіж із зазначеними реквізитами"
        },
        sender: {
          title: "Відправник"
        },
        mfo: {
          title: "МФО"
        },
        rcount: {
          title: "Розрахунковий рахунок"
        },
        summa: {
          title: "Сума платежу"
        },
        okpo: {
          title: "ОКПО"
        },
        codefirme: {
          title: "Організація"
        },
        alienpay: {
          title: "Чужий платіж"
        },
        saveforsender: {
          title: "Запам'ятати мій вибір для цього відправника"
        }
      }
    },
    bankStatColumn: {
      headers: {
        bankStatement: "Виписка банку",
        postRecording: "Занесення записи"
      }
    },
    payDocColumn: {
      headers: {
        payDoc: "Платіжні документи",
        postRecording: "Занесення записи"
      }
    },
    deleteBankStat: {
      title: "Сторнування",
      message: "Видалити вибрану банківську виписку і все її платежі?"
    },
    deleteModal: {
      title: "Видалення",
      message: "Видалити запис?"
    },
    checkImport: {
      rcount: "р/рахунок"
    },
    bankStatPostingConfirm: {
      title: "Рознести",
      message:
        "Завершити роботу з випискою банку і дозволити пов'язувати зазначені платежі з пачками?"
    }
  }
};
